export default "__VITE_ASSET__CD4KJq$7__"